import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_rade-gradnja/artifacts/zu4djkks_Logo%20RadeGradnja%20i%20Renovacije.png";

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/usluge', label: t('nav.services') },
    { path: '/galerija', label: t('nav.gallery') },
    { path: '/kontakt', label: t('nav.contact') }
  ];

  return (
    <footer className="bg-[#0B1E3B] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Logo & Description */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Rade Gradnja Logo" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#D4AF37] font-semibold text-lg mb-4 font-['Barlow_Condensed']">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm"
                    data-testid={`footer-link-${link.path.replace('/', '') || 'home'}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#D4AF37] font-semibold text-lg mb-4 font-['Barlow_Condensed']">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:+381631627662" 
                  className="flex items-center gap-3 text-gray-300 hover:text-[#D4AF37] transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  <Phone className="h-4 w-4 text-[#D4AF37]" />
                  +381 63 162 7662
                </a>
              </li>
              <li>
                <a 
                  href="mailto:radesandraerakovic@gmail.com" 
                  className="flex items-center gap-3 text-gray-300 hover:text-[#D4AF37] transition-colors text-sm"
                  data-testid="footer-email"
                >
                  <Mail className="h-4 w-4 text-[#D4AF37]" />
                  radesandraerakovic@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-300 text-sm">
                <MapPin className="h-4 w-4 text-[#D4AF37] mt-0.5" />
                <span>Gornji Milanovac - Brusnica bb</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-10 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Rade Gradnja STD. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};
